import { render, staticRenderFns } from "./HomeContact.vue?vue&type=template&id=31c6dc2a&scoped=true&"
import script from "./HomeContact.vue?vue&type=script&lang=js&"
export * from "./HomeContact.vue?vue&type=script&lang=js&"
import style0 from "./HomeContact.vue?vue&type=style&index=0&id=31c6dc2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6dc2a",
  null
  
)

export default component.exports